import {gql, useLazyQuery} from "@apollo/client";

export const GET_MINI_EVENTS_SEASON_ANCHORED = gql`
    query EventsSeasonAnchored(
        $seasonSlug: String!
        $stageId: Int
    ) {
        publicEventsBySeason(
            seasonSlug: $seasonSlug
            stageId: $stageId
        ) {
            id
            title
            eventType
            status
            date
            timezone
            responsibles
            stage {
                name
                groups {
                    name
                }
            }
            season {
                name
                division{
                    name
                    sport { key }
                    organization {
                        name
                    }
                }
                pointSystem {
                    forfeitWinScore
                    forfeitLossScore
                }
            }
            field {
                name
            }
            game {
                noPlay
                homeTeam {
                    name
                }
                homeTeamAlias
                visitorTeam {
                    name
                }
                visitorTeamAlias
                forfeitTeam {
                    id
                    name
                }
                group {
                    name
                }
                scoreHome
                scoreVisitor
                resultType
                penaltiesHome
                penaltiesVisitor
                inningScores {
                    inning
                    scoreHome
                    scoreVisitor
                }
                gameStats {
                    homeShotsOnGoal
                    awayShotsOnGoal
                    homePenaltyMinutes
                    awayPenaltyMinutes
                    homeSaves
                    awaySaves
                    homePowerPlayGoals
                    awayPowerPlayGoals
                    homePowerPlayOpportunities
                    awayPowerPlayOpportunities
                    homeHits
                    awayHits
                    homeBlockedShots
                    awayBlockedShots
                }
            }
            trainingSession {
                teams {
                    team {
                        name
                    }
                }
            }
        }
    }
    
`;

export const GET_EVENTS_SEASON_ANCHORED = gql`
    query EventsSeasonAnchored(
        $seasonSlug: String!
        $stageId: Int
        $page: Int
        $pageSize: Int!
        $anchorDate: DateTime!
    ) {
        eventsAnchorPage(seasonSlug: $seasonSlug, anchorDate: $anchorDate, pageSize: $pageSize)
        eventsBySeason(
            seasonSlug: $seasonSlug
            stageId: $stageId
            page: $page
            pageSize: $pageSize
            anchorDate: $anchorDate
        ) {
            objects {
                id
                title
                description
                eventType
                status
                date
                timezone
                responsibles
                managers
                address
                city
                state
                country
                latitude
                longitude
                stage {
                    id
                    name
                    stageReferees {
                        id
                        fullName
                        rating
                    }
                    groups {
                        id
                        name
                        teams
                    }
                }
                season {
                pointSystem {
                    forfeitWinScore
                    forfeitLossScore
                }
                division {
                    sport { key }
                }
            }
                field {
                    id
                    name
                }
                game {
                    id
                    homeTeam {
                        id
                        name
                        logoUrl
                        players {
                            playerId
                            fullName
                            shirtNumber
                        }
                    }
                    homeTeamAlias
                    visitorTeam {
                        id
                        name
                        logoUrl
                        players {
                            playerId
                            fullName
                            shirtNumber
                        }
                    }
                    visitorTeamAlias
                    forfeitTeam {
                        id
                        name
                        logoUrl
                    }
                    group {
                        id
                        name
                    }
                    matchDay
                    gameAlias
                    homeAway
                    noPlay
                    scoreHome
                    scoreVisitor
                    resultType
                    penaltiesHome
                    penaltiesVisitor
                    inningScores {
                        inning
                        scoreHome
                        scoreVisitor
                    }
                    gameStats {
                        homeShotsOnGoal
                        awayShotsOnGoal
                        homePenaltyMinutes
                        awayPenaltyMinutes
                        homeSaves
                        awaySaves
                        homePowerPlayGoals
                        awayPowerPlayGoals
                        homePowerPlayOpportunities
                        awayPowerPlayOpportunities
                        homeHits
                        awayHits
                        homeBlockedShots
                        awayBlockedShots
                    }
                }
                trainingSession {
                    participants {
                        id
                        fullName
                    }
                    teams {
                        team {
                            id
                            name
                        }
                    }
                }
                competition {
                    participants {
                        id
                        fullName
                    }
                }
                genericEvent {
                    participants {
                        id
                        fullName
                    }
                }
            }
            page
            pages
            hasNext
            hasPrev
            totalCount
        }
    }
`;

export const GAMES_IMPORT_EXCEL_TEMPLATE = gql`
    query GamesImportExcelTemplate($stageId: Int!, $maxRows: Int) {
        gamesImportExcelTemplate(stageId: $stageId, maxRows: $maxRows) {
            filename
            mimeType
            contentBase64
        }
    }
`;

export const GAMES_BLANK_IMPORT_EXCEL_TEMPLATE = gql`
    query GamesBlankImportExcelTemplate($stageId: Int!, $maxRows: Int) {
        gamesBlankImportExcelTemplate(stageId: $stageId, maxRows: $maxRows) {
            filename
            contentBase64
            mimeType
        }
    }
`;

export function useGetEventsSeasonAnchored() {
    return useLazyQuery(GET_EVENTS_SEASON_ANCHORED);
}

export function useGamesImportExcelTemplate() {
    return useLazyQuery(GAMES_IMPORT_EXCEL_TEMPLATE, {
        fetchPolicy: "no-cache",
    });
}

export function useGamesBlankImportExcelTemplate() {
    return useLazyQuery(GAMES_BLANK_IMPORT_EXCEL_TEMPLATE, {
        fetchPolicy: "network-only",
    });
}
